import { FC, memo, useState, useEffect } from 'react'
import { useRouter } from 'next/router'

import SVGImage from '~/components/Image/SVGImage'
import { MathVaultLink } from '~/types/math-vault'

import { SubMenu } from './SubMenu'

interface MenuItemProps {
  link: MathVaultLink
}

const MenuItemComponent: FC<MenuItemProps> = ({ link }) => {
  const [showSubMenu, setShowSubMenu] = useState(false)
  const [activeClass, setActiveClass] = useState({ path: '', className: '' })
  const route = useRouter()

  useEffect(() => {
    setActiveClass({ path: '', className: '' })
    setShowSubMenu(false)
  }, [route.asPath])

  const handleOnMouseLeave = (): void => {
    setActiveClass({ path: '', className: '' })
    setShowSubMenu(false)
  }

  const handleOnMouseEnter = (item: MathVaultLink): void => {
    setShowSubMenu(true)
    setActiveClass({
      path: item.path,
      className: item.activeClass.bg,
    })
  }

  return (
    <div className="h-full py-3" onMouseLeave={handleOnMouseLeave}>
      <p
        className={
          'h-10 px-2 2xl:px-3 flex items-center rounded text-xxs 2xl:text-xs text-gray-link cursor-pointer tracking-normal ' +
          `${activeClass.className}`
        }
        onMouseEnter={() => handleOnMouseEnter(link)}
      >
        <SVGImage alt={link.h1} className="w-5 mr-3" srcKey={link.icon.src} />
        <span>{link.h1}</span>
      </p>

      {showSubMenu && link?.children && (
        <div className="absolute min-w-max inset-0 transform translate-y-full z-50">
          <div className="w-full mt-1 py-4 pr-4 flex rounded bg-white shadow-experimental">
            <SubMenu items={link.children} />
          </div>
        </div>
      )}
    </div>
  )
}

const MenuItem = memo(MenuItemComponent)

export default MenuItem
